// AI domain ducks. Each AI surface (nutrition suggestion, coaching
// message, future exercise rec) gets its own action triple — keeps the
// reducer slice clean and lets components subscribe to just the field
// they care about without re-rendering on every AI dispatch.

export const GET_NUTRITION_SUGGESTION = 'ai/GET_NUTRITION_SUGGESTION';
export const GET_NUTRITION_SUGGESTION_SUCCESS =
  'ai/GET_NUTRITION_SUGGESTION_SUCCESS';
export const GET_NUTRITION_SUGGESTION_ERROR =
  'ai/GET_NUTRITION_SUGGESTION_ERROR';

export const GET_COACHING_MESSAGE = 'ai/GET_COACHING_MESSAGE';
export const GET_COACHING_MESSAGE_SUCCESS = 'ai/GET_COACHING_MESSAGE_SUCCESS';
export const GET_COACHING_MESSAGE_ERROR = 'ai/GET_COACHING_MESSAGE_ERROR';

// Trainer-side: AI briefing for a specific client. Used by the V2
// admin Assessment tab to render a 2-3 sentence summary + 3 highlight
// chips at the top.
export const GET_ASSESSMENT_SUMMARY = 'ai/GET_ASSESSMENT_SUMMARY';
export const GET_ASSESSMENT_SUMMARY_SUCCESS =
  'ai/GET_ASSESSMENT_SUMMARY_SUCCESS';
export const GET_ASSESSMENT_SUMMARY_ERROR =
  'ai/GET_ASSESSMENT_SUMMARY_ERROR';
